import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      margin: "60px 0 170px"
    },
    header: {
      "& img": {
        marginLeft: "30px"
      },
      background: theme.palette.gardient.medium,
      display: "flex",
      alignItems: "center",
      borderTopRightRadius: 6,
      borderTopLeftRadius: 6
    },
    title: {
      color: "white",
      padding: "14px 24px"
    },
    spanLine: {
      height: "34px",
      display: "flex",
      alignItems: "center"
    },
    subHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      padding: "24px 0",
      "&>div:first-child": {
        flex: "0 1 100%"
      }
    },
    selectDivHeader: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      marginTop: "16px",
      paddingLeft: "20px"
    },
    selectDivLeft: {
      display: "flex",
      alignItems: "center"
    },
    selectDivLeftEmpty: {
      display: "flex",
      alignItems: "center",
      pointerEvents: "none"
    },
    txtDisable: {
      color: `${theme.palette.grey[400]} !important`
    },
    subTitle: {
      color: theme.palette.grey[900]
    },
    subTitleDisable: {
      color: theme.palette.grey[500]
    },
    itemContainer: {
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 12,
      marginBottom: 20,
      display: "flex",
      flexWrap: "wrap",
      padding: "24px 20px",
      alignItems: "flex-start",
      "& button": {
        background: "none",
        border: "none",
        padding: 0,
        display: "inline-flex",
        marginLeft: "30px"
      }
    },
    itemCheckbox: {
      paddingTop: "5px"
    },
    itemWrapper: {
      paddingLeft: "1rem",
      flex: 1,
      display: "flex",
      alignItems: "flex-start"
    },
    itemTitle: {
      color: theme.palette.info.dark,
      fontSize: 16,
      lineHeight: "24px",
      fontWeight: 700
    },
    itemLabel: {
      fontWeight: 700,
      marginBottom: 10
    },
    gridContainer: {
      display: "grid",
      gridTemplateAreas: `
      "item1 item2 item3 item4 item5 item6 item7 item8"
      `,
      gridTemplateColumns: "50px repeat(auto-fill, auto) 200px;",
      columnGap: 16,
      rowGap: 16,
      marginTop: 24
    },
    btnContainer: {
      textAlign: "right",

      "& img": {
        cursor: "pointer"
      }
    },
    btnWrapper: {
      padding: "24px 0",
      "& div": {
        marginBottom: 18,
        cursor: "pointer"
      }
    },
    btnDelete: {
      minWidth: "auto"
    },
    inputQuantity: {
      maxWidth: "150px"
    },
    item1: {
      gridArea: "item1",
      "& .MuiFormControl-root": {
        width: "100%"
      }
    },
    item2: {
      gridArea: "item2"
    },
    item3: {
      gridArea: "item3"
    },
    item4: {
      gridArea: "item4"
    },
    item5: {
      gridArea: "item5"
    },
    item6: {
      gridArea: "item6"
    },
    item7: {
      gridArea: "item7",
      "& .MuiFormControl-root": {
        width: "100%"
      },
      "& input": {
        padding: "9px 16px !important"
      },
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: 0
      },
      "& .MuiIconButton-root": {
        border: "none",
        background: "transparent"
      },
      "& .MuiIconButton-root:hover": {
        color: theme.palette.info.dark,
        borderColor: theme.palette.info.dark
      }
    },
    item8: {
      gridArea: "item8"
    },
    item9: {
      gridArea: "item9",
      "& button": {
        maxHeight: 39
      }
    },
    item10: {
      gridArea: "item10"
    },
    flex: {
      display: "flex"
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    },
    under: {
      width: "50%",
      height: 39,
      background: theme.palette.grey[200],
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontStyle: "italic",
      color: theme.palette.grey[900]
    },
    over: {
      width: "50%",
      height: 39,
      background: theme.palette.grey[300],
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontStyle: "italic",
      color: theme.palette.grey[900]
    },
    normalText: {
      fontWeight: "normal"
    },
    actions: {
      color: theme.palette.grey[600]
    },
    subBody: {
      marginTop: 12,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 21,
      backgroundColor: "#ffffff",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "6px",
      columnGap: "8px"
    },
    errorText: {
      marginTop: 5,
      color: theme.palette.error.light
    }
  }),
  { name: "ProductDetails" }
);

export default useStyles;
